/**
 * Native submit redirect 응답 폼에 Modal.confirm 게이트만 부착.
 *
 * 사용처: 컨트롤러가 JSON 이 아닌 HTTP redirect (redirect_route) 로 응답하는 폼
 *  - admin 로그아웃 (AdminAuthController::logout → redirect_route('admin.auth.login'))
 *
 * 마크업 규약: form 에 `data-confirm-redirect="확인 메시지"` 속성 추가.
 *  - `data-admin-ajax="1"` 와 함께 쓰면 안 됨 (AJAX 핸들러가 JSON 응답을 기대해서 깨짐)
 *  - Modal.confirm 거부 → submit 중단 / 승인 → native submit 진행 (브라우저가 302 따라감)
 */
import { Modal } from "../../utils/Modal";

const SEL = 'form[data-confirm-redirect]';

export function initAdminConfirmRedirectForms(): void {
    document.body.addEventListener("submit", async (e) => {
        const form = (e.target as Element).closest<HTMLFormElement>(SEL);
        if (!form) return;
        if (form.dataset.confirmRedirectChecked === "1") return; // 재진입 방지

        e.preventDefault();
        const msg = form.getAttribute("data-confirm-redirect") ?? "";
        if (!msg) {
            form.submit();
            return;
        }

        const ok = await Modal.confirm(msg);
        if (!ok) return;

        form.dataset.confirmRedirectChecked = "1";
        form.submit();
    }, true);
}
